<div class="loader-wrapper d-flex justify-content-center">
  <div class="loader align-self-center ">
    <div class="spinner-border spinner-border-sm text-primary" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</div>
